module.exports = __webpack_public_path__ + "img/feature-icon-05.6d618086.svg";